module.exports = __webpack_public_path__ + "static/img/6.a175d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/6.png
// module id = Zo++
// module chunks = 0